import { ALLOWED_SIZES, IMAGE_SIZE_URL_SUFFIX, ImageSize } from './image-size';
import { SupportedImageTypes } from './supported-extensions.const';

export function resolveAvailableSize(availableSizes: string | undefined, target: ImageSize): ImageSize | undefined {
  if (!availableSizes) return undefined;
  const available = availableSizes
    .split(',')
    .map((size) => size.trim())
    .filter((size): size is ImageSize => ALLOWED_SIZES.includes(size as ImageSize));
  if (available.length === 0) return undefined;
  const targetIndex = ALLOWED_SIZES.indexOf(target);
  for (let index = targetIndex; index < ALLOWED_SIZES.length; index++) {
    if (available.includes(ALLOWED_SIZES[index])) return ALLOWED_SIZES[index];
  }
  for (let index = targetIndex - 1; index >= 0; index--) {
    if (available.includes(ALLOWED_SIZES[index])) return ALLOWED_SIZES[index];
  }
  return undefined;
}

export function getUrlWithSmallSuffix(url: string): string {
  let localExtension: string | undefined;
  for (let extension of SupportedImageTypes) {
    if (url.includes(extension.fileExtension)) {
      localExtension = extension.fileExtension;
      break;
    }
  }

  if (localExtension) {
    return url.replace(localExtension, IMAGE_SIZE_URL_SUFFIX.Medium + localExtension);
  } else {
    return url + IMAGE_SIZE_URL_SUFFIX.Medium;
  }
}
